import Empty from "@components/Activity/Empty";
import { InboxItemRow } from "@components/Activity/InboxItemRow";
import LBox from "@components/LBox";
import LFlatList from "@components/LFlatList";
import LScreen from "@components/LScreen";
import { useInbox } from "@hooks/inbox/useInbox";
import { theme } from "@theme";
import { router } from "expo-router";
import React from "react";
import { getInboxItemRoute } from "./inboxPresentation";

const ActivityScreen = () => {
  const { inbox, isLoadingInbox } = useInbox();

  return (
    <LScreen enableAutomaticTopPadding enableAutomaticBottomPadding p="s4">
      <LBox gap="s4" flex={1}>
        <LBox gap="s4" flex={1}>
          <LFlatList
            data={inbox}
            keyExtractor={(item) => item.id}
            contentContainerStyle={{
              gap: theme.spacing.s2,
            }}
            showsVerticalScrollIndicator={false}
            ListEmptyComponent={isLoadingInbox ? undefined : Empty}
            renderItem={({ item }) => {
              return (
                <InboxItemRow
                  item={item}
                  onPress={() => {
                    router.push(getInboxItemRoute(item.id));
                  }}
                />
              );
            }}
          />
        </LBox>
      </LBox>
    </LScreen>
  );
};

export default ActivityScreen;
